import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { register } from "./RegistrationStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import { 
  Button,
  ClickAwayListener,
  Dialog,
  FormControl, 
  Grid, 
  Input, 
  InputLabel, 
  MenuItem,
  Select,
  Typography,
 } from "@material-ui/core";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import ErrorIcon from "@material-ui/icons/Error";
import VisibilityTwoToneIcon from "@material-ui/icons/VisibilityTwoTone";
import VisibilityOffTwoToneIcon from "@material-ui/icons/VisibilityOffTwoTone";
import CloseIcon from "@material-ui/icons/Close";
import logo from "../components/Assets/tv_logo_white.png";
import axios from '../axios';
import { 
  exchange,
  decryptWithAES,
  encryptWithAES,
  home
} from '../requests';
import GoogleLogin from 'react-google-login';
import { authentication } from './firebase-config';
import { 
  //getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from 'firebase/auth';
import { useHistory } from "react-router";
import { withTheme } from "../components/Theme/Theme";
import {
  CircularProgress
} from "@material-ui/core";

const API_KEY = "oczkk67p7pyykt9xlk1eytde";

const fetchUrl = `/home_content_for_android?API-KEY=${API_KEY}`;

//const exchange = 'http://api.kallo.ng:5000';
//const exchange = 'http://localhost:5000';

const useStyles = makeStyles(register);

function SignIn() {
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phone, setPhone] = useState("+234");
  const [password, setPassword] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const [error, setError] = useState(null);
  const [errorOpen, setErrorOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [expandForm, setExpandForm] = useState(false);
  const [OTP, setOTP] = useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const generateRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
//        onSignInSubmit();
      }
    }, authentication);
  }

/*   const requestOTP = (e) => {
    e.preventDefault();
    if (!loading) {
      setLoading(true);
    if (phone.length >= 12) {
      setExpandForm(true);
      setLoading(false);
      generateRecaptcha();
      let appVerifier = window.recaptchaVerifier
      signInWithPhoneNumber(authentication, phone, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        // ...
      }).catch((error) => {
        // Error; SMS not sent
        // ...
        console.log(error);
      });
        }
      }
  } */

  const requestOTP = e => {
    e.preventDefault();
    if (!loading) {
      setLoading(true);
      if (phone.length >= 12) {
      

      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append("Access-Control-Allow-Origin", "*");
      myHeaders.append("Access-Control-Allow-Credentials", 'true');
      myHeaders.append("Access-Control-Allow-Methods", "*");

var raw = JSON.stringify({
  phoneNumber: phone,

});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${exchange}/api/v1/users/phoneAuth`, requestOptions)
  .then(response => response.json())
  .then((data) => {
    setLoading(false);
    if (data.status !== 1) {
      //otp was sent successfully make OTP SCREEN VISIBLE
      // alert("yess login");
      //setOtpHidden(true);
      setExpandForm(true);
      //setisConfirmed(true);
      //setVisible(false);
      //setAction('');
      alert(data.message);
      //redirectToHome(response.data);
} else {
alert(data.message);
//redirectToHome(response.data);
}
})
  .then(redirect())
  .catch(error => console.log('error', error));
    }
  }
  };

  /* const verifyOTP = (e) => {
    let otp = e.target.value;
    setOTP(otp);

    if (otp.length === 6) {
      if (!loading) {
        setLoading(true);
      console.log(otp)
      
      let confirmationResult = window.confirmationResult;
      confirmationResult.confirm(otp).then((result) => {
        // User signed in successfully.
        const user = result.user;
        setError('OTP Confirmed');
        setErrorOpen(true);
        PHONERegistration(result.user.uid, result.user.phoneNumber);
//        setUserID(result.user.uid)
  //      setPhoneNumber(result.user.phoneNumber);
        console.log(user);
        // ...
      }).catch((error) => {
        // User couldn't sign in (bad verification code?)
        // ...
      });

    }
  }
  }; */

  const verifyOTP = (e) => {
    let otp = e.target.value;
    setOTP(otp);

    if (otp.length === 6) {
      if (!loading) {
        setLoading(true);
      console.log(otp)
      
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append("Access-Control-Allow-Origin", "*");
      myHeaders.append("Access-Control-Allow-Credentials", 'true');
      myHeaders.append("Access-Control-Allow-Methods", "*");

var raw = JSON.stringify({
  phoneNumber: phone,
  otp: OTP

});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${exchange}/api/v1/users/otpVerify`, requestOptions)
  .then(response => response.json())
  .then((data) => {
    setLoading(false);
    if (data.status === 0) {

            //if VERIFICATION was successful, then sign in
            localStorage.setItem("token", data.token);
            localStorage.setItem("name", encryptWithAES(data.user.name));
            localStorage.setItem("email", data.user.email);
            localStorage.setItem("join_date", data.user.join_date);
            localStorage.setItem("last_login", data.user.last_login);
            localStorage.setItem("username", data.username);
            setErrorOpen(true);
            history.push('/')
} else {
alert(data.message);
//redirectToHome(response.data);
}
})
  .then(redirect())
  .catch(error => console.log('error', error));
    }}
  };

  // handle Login with Google
  const handleLogin = async googleData => {
     const res = await fetch(`${exchange}/api/v1/users/googleAuthenticate`, {
        method: "POST",
        body: JSON.stringify({
        //token: googleData.tokenId,
        email: googleData.user.email,
        name: googleData.user.name,
        id: googleData.user.id
      }),
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": 'true',
        'Access-Control-Allow-Methods': '*'
      }
    })
 
  setUser(googleData);
  console.log(googleData);
    const data = await res.json()
    // store returned user in a context?
  }

  function redirect() {
    if ("token" in localStorage) {
    history.push('/')
    }
  };

/* const CryptoJS = require('crypto-js');

const encryptWithAES = (text) => {
  const passphrase = 'kallo123';
  return CryptoJS.AES.encrypt(text, passphrase).toString();
};

const decryptWithAES = (ciphertext) => {
  const passphrase = 'kallo123';
  const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
}; */


  const errorClose = e => {
    setErrorOpen(false);
  };



  const showPassword = () => {
    setHidePassword(!hidePassword)
  };

  const isValid = () => {
    if (email === "") {
      return false;
    }
    return true;
  };

  // sign up with forms handler
  const submitRegistration = e => {
    e.preventDefault();
    if (password !== '') {
/*       setErrorOpen(true);
      setError("Passwords Entered"); */
      var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
  email: email,
  password: password

});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${exchange}/api/v1/users/authenticate`, requestOptions)
  .then(response => response.json())
  .then((data) => {
    if (data.message !== 'email or password is incorrect') {
    localStorage.setItem("token", data.token);
    localStorage.setItem("name", encryptWithAES(data.user.name));
    localStorage.setItem("email", data.user.email);
    localStorage.setItem("join_date", data.user.join_date);
    localStorage.setItem("last_login", data.user.last_login);
    //history.push('/');
    history.goBack();
//    console.log('name', data.user.name)
    }
    else {
      alert(data.message);
      history.push('/sign-in');
    }
  })
  .then(redirect())
  .catch(error => console.log('error', error));
    }
  };

  const PHONERegistration = (uid, phone) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      var raw_phone = JSON.stringify({
        phone: phone,
        uid: uid,
      });
      
      var phoneRequestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw_phone,
        redirect: 'follow'
      };
      
    //this fetch request is for phone authentication/registation?
    fetch(`${exchange}/api/v1/users/phoneAuthenticate`, phoneRequestOptions)
    .then(response => response.json())
    .then((data) => {
      console.log(data);
      if (data.message !== "login success") {
      //if registration was not successful,
//        setErrorOpen(true);
//      setError(data.message);
      alert(data.message)
    }
    else {
      //if registration was successful, then sign in
      localStorage.setItem("token", data.token);
      localStorage.setItem("name", encryptWithAES(data.user.name));
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("join_date", data.user.join_date);
      localStorage.setItem("last_login", data.user.last_login);
      localStorage.setItem("username", data.username);
      setErrorOpen(true);
      history.push('/')
    }
  })
    .catch(error => console.log('error', error));
/*     const newUserCredentials = {
      email: email,
      password: password,
      passwordConfrim: passwordConfrim
    };
    console.log(newUserCredentials); */
    //dispath to userActions
  };



    return (
      <div className={classes.main}>
        <CssBaseline />

        <Paper className={classes.paper}>
        <Link to='/'>
            <img className={classes.avatar}
            src={logo}
            alt="Kallo.ng Logo"
            />
            </Link>
<Grid container >
<Grid item xs > 
       <Button
              disabled
              disableRipple
              fullWidth
//              variant="contained"
//              className={classes.button}
              type="submit"
              onClick={submitRegistration}
              style={{color: '#fff'}}
            >
        <Typography variant="h6" display="block" gutterBottom noWrap>
            Phone Sign In | Shiga
          </Typography>
              </Button>
          </Grid>
<Grid item xs align='center'> 
          <Button 
          fullWidth
          className={classes.button}
          style={{color: '#fff', backgroundColor: '#8b0000'}}
          href="/sign-in"
          >Sign In | Shiga</Button>
          </Grid>
</Grid>
<Grid container> 
<Grid item xs>
  {''}
</Grid>
</Grid>
<>
          <form
            className={classes.form}
            onSubmit={requestOTP}
          >
            <Grid container align='center'>
            <Grid item xs={12} sm={12} > 
                        <FormControl required fullWidth margin="normal">
              <InputLabel htmlFor="email" className={classes.labels}>
                Phone Number
              </InputLabel>
              <Input
                name="phone"
                type="tel"
                value={phone}
                //autoComplete="tel"
                className={classes.inputs}
                disableUnderline={true}
                onChange={(e) => setPhone(e.target.value)}
              />
              </FormControl>
              </Grid>
{/*             <Grid item xs={12} sm={12} > 
              <FormControl required fullWidth margin="normal">
                            <InputLabel htmlFor="password" className={classes.labels}>
                Password
              </InputLabel>
              <Input
                name="password"
                autoComplete="password"
                className={classes.inputs}
                disableUnderline={true}
                onChange={(e) => setPassword(e.target.value)}
                type={hidePassword ? "password" : "input"}
                endAdornment={
                  hidePassword ? (
                    <InputAdornment position="end">
                      <VisibilityOffTwoToneIcon
                        fontSize="default"
                        className={classes.passwordEye}
                        onClick={showPassword}
                      />
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="end">
                      <VisibilityTwoToneIcon
                        fontSize="default"
                        className={classes.passwordEye}
                        onClick={showPassword}
                      />
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
            </Grid> */}
            {expandForm === true ?
            <Grid item xs={12} sm={12} > 
            <FormControl required fullWidth margin="normal">
              <InputLabel htmlFor="password" className={classes.labels}>
                Enter OTP
              </InputLabel>
              <Input
                name="OTP"
                value={OTP}
                autoComplete="password"
                className={classes.inputs}
                disableUnderline={true}
                //onChange={(e) => setOTP(e.target.value)}
                onChange={verifyOTP}
                type='number'
              />
            </FormControl>
            {loading && 
     <CircularProgress
      size={24}
      className={classes.buttonProgress}
    />}
            </Grid> :  
            null
}
{ expandForm === false ? 
            <Grid item xs={12} sm={6}>
            <Button
//              fullWidth
              variant="outlined"
              className={classes.button}
              type="submit"
              style={{color: '#fff'}}
            >
              Request OTP
            </Button>
            </Grid> 
            : null
}
            </Grid> 
        <div id='recaptcha-container'> </div>
          </form>
          </>

          {error ? (
            <Snackbar
              variant="success"
              key={error}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              open={errorOpen}
              onClose={errorClose}
              autoHideDuration={3000}
            >
              <SnackbarContent
                className={classes.success}
                message={
                  <div>
                    <span style={{ marginRight: "8px" }}>
                      <ErrorIcon fontSize="large" color="success" />
                    </span>
                    <span> {error} </span>
                  </div>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    onClick={errorClose}
                  >
                    <CloseIcon color="error" />
                  </IconButton>
                ]}
              />
            </Snackbar>
          ) : null}

        </Paper>

        <div style={{backgroundColor: '#222'}} >

      </div>
      </div>
    );
}

export default withTheme(SignIn);